<template>
  <div>
    <v-card class="elevation-4">
      <v-card-title class="grey lighten-3">
        <h3 class="headline pl-3">Settings</h3>
        <v-spacer></v-spacer>
        <v-btn v-if="user.premium" color="info" @click="$emit('saveTest')"
          >Save Test</v-btn
        >
        <v-btn
          v-else-if="!user.email"
          color="info"
          @click="$router.push('account/register')"
          >Save Test</v-btn
        >
        <v-btn
          v-else-if="!user.premium"
          color="info"
          @click="$router.push('account/billing')"
          >Save Test</v-btn
        >
      </v-card-title>
      <v-form class="pa-2">
        <v-layout row wrap>
          <v-flex class="pl-1 xs12 md3" v-if="firebase.auth.currentUser">
            <v-select
              label="Pool"
              v-model="settings.pool"
              :items="settings.pools"
              item-text="name"
              :return-object="true"
              @input="update"
            />
          </v-flex>
          <v-flex class="pl-1 xs12 md3">
            <v-select
              label="Type"
              v-model="settings.type"
              :items="settings.types"
              @input="update"
            />
          </v-flex>
          <v-flex class="pl-1 xs12 md3">
            <v-select
              label="Surface"
              v-model="settings.surface"
              :items="settings.surfaces"
              @input="update"
            />
          </v-flex>
          <v-flex class="pl-1 xs12 md3">
            <v-select
              label="Unit Type"
              v-model="settings.unitType"
              :items="settings.unitTypes"
              @input="update"
            />
          </v-flex>
          <v-flex class="pl-1 xs12 md3">
            <v-select
              label="Ranges"
              v-model="settings.range"
              :items="settings.ranges"
              item-text="name"
              :return-object="true"
              @input="update"
            />
          </v-flex>
          <v-flex
            class="pl-1 xs12 md3"
            v-if="settings.range.name === 'TroubleFreePool.com'"
          >
            <v-select
              label="Chlorine Source"
              v-model="settings.chlorineSource"
              :items="settings.chlorineSources"
              @input="update"
            />
          </v-flex>
          <v-flex class="pl-1 xs12 md3">
            <v-text-field
              :label="labels.volume"
              v-model="settings.volume"
              @input="update"
            />
          </v-flex>
          <v-flex class="pl-1 xs12 md3">
            <v-text-field
              :label="labels.temperature"
              v-model="settings.temperature"
              @input="update"
            />
          </v-flex>
        </v-layout>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import firebase from "@/firebase";
export default {
  name: "Settings",
  emits: ["saveTest"],
  data() {
    return {
      firebase,
      labels: {
        temperature: "Temperature",
        volume: "Volume",
      },
    };
  },
  computed: {
    ...mapGetters({
      borate: "borate/getBorate",
      ch: "ch/getCH",
      cya: "cya/getCYA",
      fc: "fc/getFC",
      ph: "ph/getPH",
      salt: "salt/getSalt",
      settings: "settings/getSettings",
      ta: "ta/getTA",
      user: "user/getUser",
    }),
  },
  methods: {
    ...mapActions({
      initSettings: "settings/initSettings",
      saveBorate: "borate/saveBorate",
      saveCH: "ch/saveCH",
      saveCYA: "cya/saveCYA",
      saveFC: "fc/saveFC",
      savePH: "ph/savePH",
      saveSettings: "settings/saveSettings",
    }),
    ...mapMutations({
      calcBorate: "borate/calcBorate",
      calcCH: "ch/calcCH",
      calcCYA: "cya/calcCYA",
      calcFC: "fc/calcFC",
      calcPH: "ph/calcPH",
      calcSalt: "salt/calcSalt",
      calcTA: "ta/calcTA",
      setBorate: "borate/setBorate",
      setCH: "ch/setCH",
      setCYA: "cya/setCYA",
      setFC: "fc/setFC",
      setPH: "ph/setPH",
      setFCRange: "settings/setFC",
      setTFPCH: "settings/setTFPCH",
      setTFPCYA: "settings/setTFPCYA",
      setTFPTA: "settings/setTFPTA",
      setSettings: "settings/setSettings",
    }),
    setLabels() {
      this.labels.volume = `Volume (${
        this.settings.unitType === "Metric" ? "litres" : "gallons"
      })`;
      this.labels.temperature = `Temperature  (${
        this.settings.unitType === "Metric" ? "°C" : "°F"
      })`;
    },
    setPool() {
      this.poolName = this.settings.pool.name;
      this.settings.type = this.settings.pool.type;
      this.settings.surface = this.settings.pool.surface;
      this.settings.unitType = this.settings.pool.units;
      this.settings.volume = this.settings.pool.volume;
      this.borate.type = this.settings.pool.borate;
      this.ch.type = this.settings.pool.ch;
      this.cya.type = this.settings.pool.cya;
      this.fc.type = this.settings.pool.fc || this.fc.types[0];
      this.ph.lowerType = this.settings.pool.phLower;
      this.ph.raiseType = this.settings.pool.phRaise;
      this.setSettings(this.settings);
      this.setBorate(this.borate);
      this.setCH(this.ch);
      this.setCYA(this.cya);
      this.setFC(this.fc);
      this.setPH(this.ph);

      this.saveSettings(this.settings);
    },
    async update() {
      if (this.settings.pool.name !== this.poolName) this.setPool();
      this.fc.jugSizes = this.fc.allJugSizes[this.settings.unitType];
      const jugSize = this.fc.jugSizes.filter(
        (j) => j.name === this.fc.jugSize.name
      );
      this.fc.jugSize = jugSize.length < 1 ? this.fc.jugSizes[0] : jugSize[0];
      this.setSettings(this.settings);
      this.setFC(this.fc);
      this.setFCRange();
      this.setTFPCH();
      this.setTFPCYA();
      this.setTFPTA();
      this.calcBorate(this.settings);
      this.calcCH(this.settings);
      this.calcCYA(this.settings);
      this.calcFC(this.settings);
      this.calcPH({
        borate: this.borate.tested,
        settings: this.settings,
        ta: this.ta.tested,
      });
      this.calcSalt(this.settings);
      this.calcTA(this.settings);
      await this.saveSettings(this.settings);
      this.setLabels();
    },
  },
  async mounted() {
    await this.initSettings();
    if (this.settings.pools.length > 0) {
      let foundPool = null;
      for (let i = 0; i < this.settings.pools.length; i++) {
        const pool = this.settings.pools[i];
        if (pool.id === this.settings.pool.id) {
          foundPool = pool;
          break;
        }
      }

      if (foundPool === null) foundPool = this.settings.pools[0];

      this.setSettings({ pool: foundPool });
      this.saveSettings(this.settings);
    }
    if (this.settings.pool.name) this.setPool();
    this.setLabels();
  },
};
</script>
